import { HTTP_SUCCESS } from '../../constants/HttpConstants';
import {
    REQUEST_CURRENT_USER,
    REQUEST_CURRENT_USER_FINISHED,
    REQUEST_PUT_OWN_USER,
    REQUEST_PUT_OWN_USER_FINISHED,
    REQUEST_SAVE_USER,
    REQUEST_SAVE_USER_FINISHED,
    RESET_CURRENT_USER,
    RESET_SAVE_USER
} from './user/UserAction';
import { REQUEST_USERINFO, REQUEST_USERINFO_FINISHED } from './UserInfoAction';

export default function userInfoReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_USERINFO:
      return {
        ...state,
        saveUserError: undefined,
        saveUserStatus: undefined
      };
    case REQUEST_USERINFO_FINISHED:
      if (action.payload?.errors) {
        return {
          ...state,
          error: action.payload
        };
      } else {
        return action.payload;
      }
    case REQUEST_SAVE_USER:
      return {
        ...state,
        saveUserError: undefined,
        saveUserStatus: undefined
      };
    case REQUEST_SAVE_USER_FINISHED:
      if (action.payload?.errors) {
        return {
          ...state,
          saveUserError: action.payload,
          saveUserStatus: action.payload.status
        };
      } else {
        return {
          ...state,
          user: action.payload,
          saveUserError: undefined,
          saveUserStatus: HTTP_SUCCESS
        };
      }
    case RESET_SAVE_USER:
      return {
        ...state,
        saveUserError: undefined,
        saveUserStatus: undefined
      };

    case REQUEST_PUT_OWN_USER:
      return {
        ...state,
        isOwnUserUpdating: true,
        updateUserError: undefined,
      };
    case REQUEST_PUT_OWN_USER_FINISHED:
      if (action.payload?.errors) {
        return {
          ...state,
          isOwnUserUpdating: false,
          updateUserError: action.payload,
        };
      }
      return {
        ...state,
        isOwnUserUpdating: false,
        updateUserError: undefined
      };
    case REQUEST_CURRENT_USER:
      return {
        ...state,
        currentUser: undefined,
        currentUserError: undefined,
        isCurrentUserLoading: true
      };
    case REQUEST_CURRENT_USER_FINISHED:
      if (action.payload?.errors) {
        return {
          ...state,
          currentUser: undefined,
          currentUserError: action.payload,
          isCurrentUserLoading: false
        };
      }
      return {
        ...state,
        currentUser: action.payload,
        currentUserError: undefined,
        isCurrentUserLoading: false
      };
    case RESET_CURRENT_USER:
      return {
        ...state,
        currentUser: undefined,
        currentUserError: undefined,
        isCurrentUserLoading: false,
        isOwnUserUpdating: false,
        updateUserError: undefined
      };
    default:
      return state;
  }
}

